module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.79/js/sprocket_orange.svg"